const dragonGlobal = 'https://d23hwblhugcea5.cloudfront.net/Global';

export const avatarsGLTFURL: any = [
  `${dragonGlobal}/avatars/RPM1/Alex.glb`,
  `${dragonGlobal}/avatars/RPM1/Amy.glb`,
  `${dragonGlobal}/avatars/RPM1/Billy.glb`,
  `${dragonGlobal}/avatars/RPM1/Emma.glb`,
  `${dragonGlobal}/avatars/RPM1/Erick.glb`,
  `${dragonGlobal}/avatars/RPM1/Erika.glb`,
  `${dragonGlobal}/avatars/RPM1/Jason.glb`,
  `${dragonGlobal}/avatars/RPM1/John.glb`,
  `${dragonGlobal}/avatars/RPM1/Jane.glb`,
  `${dragonGlobal}/avatars/RPM1/Jaqueline.glb`,
];

export const propsGLTFURL: any = [
  {
    name: 'Build scene AR1-0',
    thumbnail: `${dragonGlobal}/build_library/public_GLTF/drop1/Art/previews/AR1_1_Preview.jpg`,
    url: `${dragonGlobal}/build_library/public_GLTF/drop1/Art/AR1_1/AR1_1.gltf`,
    nameObject: 'AR1',
  },
  {
    name: 'Build scene AR2-1',
    thumbnail: `${dragonGlobal}/build_library/public_GLTF/drop1/Art/previews/AR1_2_Preview.jpg`,
    url: `${dragonGlobal}/build_library/public_GLTF/drop1/Art/AR1_2/AR1_2.gltf`,
    nameObject: 'AR2',
  },
  {
    name: 'Build scene AR3-2',
    thumbnail: `${dragonGlobal}/build_library/public_GLTF/drop1/Art/previews/AR1_3_Preview.jpg`,
    url: `${dragonGlobal}/build_library/public_GLTF/drop1/Art/AR1_3/AR1_3.gltf`,
    nameObject: 'AR3',
  },
  {
    name: 'Build scene AR4-3',
    thumbnail: `${dragonGlobal}/build_library/public_GLTF/drop1/Art/previews/AR1_4_Preview.jpg`,
    url: `${dragonGlobal}/build_library/public_GLTF/drop1/Art/AR1_4/AR1_6.gltf`,
    nameObject: 'AR4',
  },
  {
    name: 'Build scene AR5-4',
    thumbnail: `${dragonGlobal}/build_library/public_GLTF/drop1/Art/previews/AR1_5_Preview.jpg`,
    url: `${dragonGlobal}/build_library/public_GLTF/drop1/Art/AR1_5/AR1_9.gltf`,
    nameObject: 'AR5',
  },
  {
    name: 'Build scene AR6-5',
    thumbnail: `${dragonGlobal}/build_library/public_GLTF/drop1/Art/previews/AR1_6_Preview.jpg`,
    url: `${dragonGlobal}/build_library/public_GLTF/drop1/Art/AR1_6/AR1_10.gltf`,
    nameObject: 'AR6',
  },
  {
    name: 'Build scene AR7-6',
    thumbnail: `${dragonGlobal}/build_library/public_GLTF/drop1/Art/previews/AR1_7_Preview.jpg`,
    url: `${dragonGlobal}/build_library/public_GLTF/drop1/Art/AR1_7/AR1_11.gltf`,
    nameObject: 'AR7',
  },
  {
    name: 'Build scene AR8-7',
    thumbnail: `${dragonGlobal}/build_library/public_GLTF/drop1/Art/previews/AR1_8_Preview.jpg`,
    url: `${dragonGlobal}/build_library/public_GLTF/drop1/Art/AR1_8/AR1_13.gltf`,
    nameObject: 'AR8',
  },
  {
    name: 'Build scene AR9-8',
    thumbnail: `${dragonGlobal}/build_library/public_GLTF/drop1/Art/previews/AR1_9_Preview.jpg`,
    url: `${dragonGlobal}/build_library/public_GLTF/drop1/Art/AR1_9/AR1_17.gltf`,
    nameObject: 'AR9',
  },
  {
    name: 'Build scene BR1-9',
    thumbnail: `${dragonGlobal}/build_library/public_GLTF/drop1/Bridges/previews/BR1_1_Preview.jpg`,
    url: `${dragonGlobal}/build_library/public_GLTF/drop1/Bridges/BR1_1/BR1_1.gltf`,
    nameObject: 'BR1',
  },
];
